import { 
    EditOutlined, SaveOutlined, 
    RollbackOutlined, PlusOutlined,
    MinusOutlined,
} from '@ant-design/icons';

import { 
	AiOutlineNodeCollapse, AiOutlineNodeExpand,
} from "react-icons/ai";

import { 
  LuPanelLeftOpen, LuPanelLeftClose,
  LuFileText, LuClipboardCheck,
  LuTarget, LuUserCheck,
  LuSend, LuThumbsUp,
  LuAward, LuCheckCircle2,
  LuBriefcase, LuWifi,
  LuHardDrive, LuShield,
  LuMonitor, LuSmartphone,
  LuPrinter, 
 } from "react-icons/lu";


import { PH, AU, AT} from 'country-flag-icons/react/3x2';
import dayjs from "dayjs";

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_MDY = 'MM-DD-YYYY';
export const TIME_FORMAT = 'HH:mm:ss';
export const TIME_FORMAT_HM = 'hh:mm';
export const TIME_FORMAT_24HM = 'HH:mm';
export const TIME_FORMAT_12HM = 'hh:mm a';
export const SEPARATED_ID = 4;

export const BUTTON_ICONS = {
    Add: PlusOutlined,
    Edit: EditOutlined,
    Save: SaveOutlined,
    Cancel: RollbackOutlined,
    MenuCollapse: LuPanelLeftClose, 
    MenuExpand: LuPanelLeftOpen,
};

export const CLIENT_STATUS_COLORS = {
    TBD: 'light',
    Active: 'primary',
    Inactive: 'dark',
}

export const EMPLOYMENT_STATUS_COLORS = {
    TBD: 'light',
    Active: 'primary',
    Inactive: 'dark',
}

export const COUNTRY_FLAG_ICONS = {
  PH: <PH title="Philippines" className="rounded-sm w-6 h-4" />,
  AU: <AU title="Australia" className="rounded-sm w-6 h-4" />,
  AT: <AT title="Austria" className="rounded-sm w-6 h-4" />,
};

export const STAFF_STATUS_COLORS = {
    TBD: 'light',
    Active: 'primary',
    Inactive: 'dark',
}


export const MONTH_NAMES = Array.from({ length: 12 }, (_, i) =>
  dayjs().month(i).format("MMMM")
);

export const MONTH_OPTIONS = MONTH_NAMES.map((name, i) => ({
  value: i + 1,
  label: name,
}));

export const getDaysInMonth = (month) =>
  dayjs(`2000-${String(month).padStart(2, "0")}-01`).daysInMonth();

export const getDayOptions = (month) =>
  Array.from({ length: getDaysInMonth(month) }, (_, i) => ({
    value: i + 1,
    label: i + 1,
  }));


export const PIPELINE_STEPS = {
  Application: LuFileText,
  Screening: LuClipboardCheck,
  Testing: LuTarget,
  Shortlisting: LuUserCheck,
  "Client Endorsement": LuSend,
  "Client Selection": LuThumbsUp,
  References: LuAward,
  Offer: LuCheckCircle2,
  Onboarding: LuBriefcase,
}

export const CATEGORY_ICONS = {
  Network: LuWifi,
  Account: LuShield,
  Software: LuHardDrive,
  Hardware: LuMonitor,
  Mobile: LuSmartphone,
  Printer: LuPrinter,
};

export const ROLE_SUPER_ADMIN = 1;
export const ROLE_ACCT_ADMIN = 2;
export const ROLE_ACCT_USER = 3;
export const ROLE_CLIENT = 4;
export const ROLE_EMPLOYEE = 5;

export const MODULE_DASHBOARD = 6;
export const MODULE_TEAM_MENU = 7;
export const MODULE_CLIENT = 8;
export const MODULE_EMPLOYEES = 9;
export const MODULE_SALARIES = 10;
export const MODULE_PAYROLL_MENU = 11;
export const MODULE_PAYROLLS = 12;
export const MODULE_SAL_ADJUSTMENTS = 13;
export const MODULE_SAL_DEDUCTIONS = 14;
export const MODULE_SAL_ADDITIONS = 15;
export const MODULE_FINAL_PAYS = 16;
export const MODULE_FINANCE = 17;
export const MODULE_INVOICES = 18;
export const MODULE_MANUAL_JOURNALS = 19;
export const MODULE_CLIENT_EXPENSE= 20;
export const MODULE_INVOICE_ADJUSTMENTS = 21;
export const MODULE_REPORTS = 22;
export const MODULE_ACCESS_MANAGEMENT_MENU = 23;
export const MODULE_ACCESS_MANAGER = 24;
export const MODULE_USERS = 25;
export const MODULE_ACCESS_GROUPS = 26;
export const MODULE_ACCESS_RIGHTS = 27;
export const MODULE_MODULES = 28;
export const MODULE_SETTINGS_MENU = 29;
export const MODULE_HOLIDAYS = 30;
export const MODULE_OPTION_GROUPS = 31;
export const MODULE_OPTIONS = 32;
export const MODULE_PAYCODES = 33;
export const MODULE_USER_GUIDE = 34;
export const MODULE_SYSTEM_CHECK = 35;
export const MODULE_TIMEKEEPING = 36;
export const MODULE_TIMECARDS = 37;
export const MODULE_OVERTIME = 38;
export const MODULE_LEAVE = 39;
export const MODULE_MYPAYSLIPS = 40;
export const MODULE_RECRUITMENT = 41;
export const MODULE_JOB_POSTS = 42;
export const MODULE_RECRUITMENT_OVERVIEW = 43;
export const MODULE_JOBROLES = 44;
export const MODULE_JOBROLE_REQS = 45;
export const MODULE_TRAINING = 46;
export const MODULE_TRAINING_MOD = 47;
export const MODULE_TRAINING_REQ = 48;
export const MODULE_TRAINING_CLASS = 49;